module.exports = __webpack_public_path__ + "img/icon-event.834ac312.svg";